module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('xcurd', {
    attrs: {
      "topBtns": _vm.topBtns,
      "dialogs": _vm.dialogs,
      "table": _vm.table
    },
    on: {
      "clickRowBtn": function($event) {},
      "clickMultiBtn": function($event) {},
      "clickTopBtn": function($event) {}
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-650f7b2a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/store/order_old.vue
// module id = 223
// module chunks = 2